import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CoreState } from './core.state';

// selectors
export const selectCoreModule = createFeatureSelector<CoreState>('core');
export const selectAppReady = createSelector(selectCoreModule, (state: CoreState) => state.appReady);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/core.selector.ts